// extracted by mini-css-extract-plugin
export default {"form":"SectionFormContact_form__UzTlu"};